<div class="btn-filter-container">
  <div class="button-wrap" [ngClass]="{ 'icon-only': !showMainButton }"
    [style.--btn-color]="!showMainButton ? '#ffffff' : '#118DFF'">
    <button *ngIf="showMainButton" class="btn" [ngClass]="{ 'btn-selected': isSelected() }" (click)="onClick(data.key)">
      {{ data.label }}
    </button>

    <button *ngIf="isResetVisible" type="button" class="reset-icon-btn" [style.height]="data?.iconHeight"
      matTooltip="Reset filters" matTooltipPosition="above" (click)="onResetClick($event)">
      <mat-icon class="material-symbols-outlined">filter_alt_off</mat-icon>
      <span class="btn-text ms-1">Reset</span>
    </button>

    <div *ngIf="isResetVisible && isInsightVisible && !showMainButton"
      style="width: 1px; height: 16px; background-color: #ffffff; margin: 0 4px; flex-shrink: 0; align-self: center;">
    </div>

    <button *ngIf="isInsightVisible" type="button" class="insight-icon-btn"
      [style.height]="data?.iconHeight" [matTooltip]="insightTooltipText"
      matTooltipClass="insight-tooltip-panel" matTooltipPosition="above" (click)="$event.stopPropagation()">
      <mat-icon class="material-symbols-outlined">info</mat-icon>
    </button>
  </div>
</div>